<template>
    <div class="equipment">
        <h1 class="title">房東提供</h1>
        <div class="items">
            <span v-for="(item, index) in equipment" :key="index" :class="{'has': item.check == true, 'no-has': item.check == false}" class="has">
                <img v-if="item.check" src="@/assets/img/shareHouse/check_red.svg" alt="">
                <img v-else src="@/assets/img/shareHouse/cross_gray.svg" alt="">
                {{item.itemName}}
            </span>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            equipment: 'GET_SHARE_HOUSE_EQUIPMENT',
        })
    },
}
</script>
<style lang="scss" scoped>
    .equipment{
        position: relative;
        width: 100%;
        margin-bottom: -12px;
        h1.title{
            margin-bottom: 20px;
            font-size: 28px;
            color: #3a455f;
        }
        .items{
            display: flex;
            flex-wrap: wrap;
            width: 94.61%;
            span{
                flex: 0 0 19.21%;
                font-size: 16px;
                margin-bottom: 12px;
                img{
                    margin-right: 9.5%;
                }
            }
            span.no-has{
                color: #909090;
            }
        }
        // ul{
        //     display: flex;
        //     align-items: center;
        //     flex-wrap: wrap;
        //     li{
        //         width: 88px;
        //         img{
        //             margin-right: 14px;
        //         }
        //     }
        // }
    }
    @media (max-width: 992px) {
        .equipment{
            h1.title{
                margin-bottom: 16px;
                font-size: 20px;
            }
            .items{
                width: 100%;
                span{
                    flex: 0 0 33%;
                    font-size: 16px;
                    margin-bottom: 12px;
                    img{
                        margin-right: 9.5%;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/equipment.vue